export default function Footer() {
    const style = {
        fontSize: "12px",
    }
    return <>
    <p className="copyright" style={style}>Copyright © 2022 Bookin</p></>
}